module.exports = __webpack_public_path__ + "img/compartir-icon.cada5fe1.svg";